import Vue from 'vue';
import VueRouter from 'vue-router';
import APIS from '@apis';
import routes from '@constants/_routes';

Vue.use(VueRouter);

const checkRouteExist = (route, routeArray=[]) => { // 必须保证router的name是唯一的
  for (let i = 0; i < routeArray.length; i++) {
    if (route.path === routeArray[i].path || route.name === routeArray[i].name) {
      return true;
    }
  }
  return false;
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE,
  routes
});
router.beforeEach((to, from, next) => { // 路由守卫动态添加路由的功能
  try {
    const routeExist = checkRouteExist(to, routes);
    const routeExists = checkRouteExist(to, Vue.store.state.activeRoutes);
    if(routeExist || routeExists) { // 在固定路由和动态路由中存在则不进行任何操作
      next();
    } else {
      APIS.getRoutes().then(res => {
        const activeTempRoutes = JSON.parse(res.data);
        const activeRoutes = activeTempRoutes.map(item => {
          return {
            path: `/pages/${item.path}`,
            name: item.name,
            component: () => import(`@views/${item.componentPath}/${item.component}.vue`)
          }
        });
        Vue.store.commit('setActiveRoutes', activeRoutes);
        const activeRouteExist = checkRouteExist(to, activeRoutes);
        if (activeRouteExist) {
          router.addRoutes(activeRoutes);
          next({...to, replace: true});
        } else {
          next(false);
        }
      }).catch(() => {
        next(false);
      })
    }
  } catch {
    next(false);
  }
});

export default router;

